import { createPopper } from '@popperjs/core';

export function useVSelectPopper(options = {}) {
  const defaultPlacement = options.placement || 'bottom';
  
  const defaultOffset = options.offset || [0, -1];

  const withPopper = (dropdownList, component, { width }) => {
    dropdownList.style.width = width;

    const isInViewport = (element) => {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.bottom <= window.innerHeight &&
        rect.left >= 0 &&
        rect.right <= window.innerWidth
      );
    };

    const handleScroll = () => {
      if (!isInViewport(component.$refs.toggle)) {
        component.closeSearchOptions();
        if (component.$refs.search) {
          component.$refs.search.blur();
        }
      }
    };

    window.addEventListener('scroll', handleScroll, true);

    const popper = createPopper(component.$refs.toggle, dropdownList, {
      placement: defaultPlacement,
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: defaultOffset,
          },
        },
        {
          name: 'toggleClass',
          enabled: true,
          phase: 'write',
          fn({ state }) {
            component.$el.classList.toggle(
              'drop-up',
              state.placement === 'top'
            );
          },
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['top', 'bottom'],
            padding: 8,
          },
        },
        {
          name: 'preventOverflow',
          options: {
            boundary: 'viewport',
            padding: 8,
            altAxis: true,
            tether: false,
          },
        },
        {
          name: 'maxHeight',
          enabled: true,
          phase: 'beforeWrite',
          requires: ['computeStyles'],
          fn({ state, instance }) {
            const { placement } = state;
            const viewportHeight = window.innerHeight;
            
            const referenceElement = instance.state.elements.reference;
            const liveRect = referenceElement.getBoundingClientRect();
            
            let availableSpace;
            if (placement.startsWith('top')) {
              availableSpace = liveRect.top - 90;
            } else {
              availableSpace = viewportHeight - liveRect.bottom - 16;
            }
            
            const maxHeight = Math.min(availableSpace, 300);
            
            state.styles.popper.maxHeight = `${maxHeight}px`;
          },
        },
      ],
    });

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
      popper.destroy();
    };
  };

  return {
    withPopper,
  };
}

